import { useCallback } from "react";
import moment from "moment";
import { useCurrentUserQuery } from "../../../../../../../../../../api/queries/useUserQuery";
import { PATIENT_CHAT_MESSAGE_TYPES } from "../../../../../../../../../../api/patient/usePatientSmsQuery";
import { MSG_TYPE } from "../../../../../../../../../../boxes/Chat/config";
import {
  DEFAULT_TIME_FORMAT,
  PREVIEW_DATE_FORMAT,
} from "../../../../../../../../../../consts/general";
import { useClientQuery } from "../../../../../../../../../../api/queries/useClientQuery";

export const useChatMessageAdapter = (patientId) => {
  const { data } = useCurrentUserQuery();
  const { data: patient } = useClientQuery({ clientId: patientId });

  return useCallback(
    (apiMessage) => ({
      id: apiMessage.id,

      type:
        apiMessage.message_type === PATIENT_CHAT_MESSAGE_TYPES.fromPatient
          ? MSG_TYPE.toMe
          : MSG_TYPE.fromMe,

      message: apiMessage.message,

      date: moment
        .utc(apiMessage.created)
        .format(data?.previewDateFormat || PREVIEW_DATE_FORMAT),

      time: moment
        .utc(apiMessage.created)
        .format(data?.timeFormat || DEFAULT_TIME_FORMAT),

      userImageUrl:
        apiMessage.message_type === PATIENT_CHAT_MESSAGE_TYPES.fromPatient
          ? patient?.imageUrl
          : apiMessage.user?.user_image_url,

      userName:
        apiMessage.message_type === PATIENT_CHAT_MESSAGE_TYPES.fromPatient
          ? patient?.fullName
          : apiMessage.user?.full_name || "Unknown User",
    }),
    [
      data?.previewDateFormat,
      data?.timeFormat,
      patient?.fullName,
      patient?.imageUrl,
    ],
  );
};
